import { apiClient, getAuthToken } from './client';

export type TagOption = { value: string; label: string };

export const queryTagOptions = async (
  input: { projectId?: string | null },
  token?: string,
  orgId?: string | null,
): Promise<TagOption[]> => {
  const params = new URLSearchParams();
  if (input.projectId) {
    params.set('projectId', input.projectId);
  }
  const query = params.toString();
  const path = query.length > 0 ? `/tags?${query}` : '/tags';
  return await apiClient.get<TagOption[]>(path, {
    token: token ?? getAuthToken(),
    orgId,
  });
};
